<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00037.installation.cellule.titre' | translate"
      [description]="'P00037.installation.cellule.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P00037.installation.polarite' | translate"
      [nameCustom]="'P00037.installation.activation' | translate"
      [value]="actionStack!.getValue('elPDureeInversionPolarite') !== 0"
      [information]="P00037ESPPolarite"
      (onPress)="
        !$event
          ? actionStack!.editValue(
              P00039DataRxTxIndex.SALT_Parametrage1,
              'elPDureeInversionPolarite',
              0,
              null
            )
          : this.actionStack!.editValue(
              P00039DataRxTxIndex.SALT_Parametrage1,
              'elPDureeInversionPolarite',
              4,
              null
            )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('elPDureeInversionPolarite') > 0) {
      <app-label-configuration
        [titleListe]="'P00037.installation.inversion' | translate"
        [value]="actionStack!.getValue('elPDureeInversionPolarite')"
        [liste]="P00037DureeInversion"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.SALT_Parametrage1,
            'elPDureeInversionPolarite',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="'P00037.installation.activationHelper' | translate"
    ></app-label-description>

    <app-larged-link
      [name]="'P00037.installation.config.position' | translate"
      [textBeforeArrow]="
        P00037PositionTypeEnum[this.currentForm!.controls['position']?.value]
          .label | translate
      "
      (onPress)="openModal()"
    >
    </app-larged-link>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
